// import MockStorage from './MockStorage';

import Core from '../Core/Core';
import getLogger, { ILogger } from '../Core/Logger';

const logger: ILogger = getLogger('[STORAGE-LOCAL]:');

export class Storage {
    private static get playerKey(): string {
        if (!this.cachedPlayerKey) {
            this.cachedPlayerKey =
                this.hash(this.encryption(Core.sdk.user.name)) +
                Core.sdk.user.userId[0] +
                Core.sdk.user.name[0] +
                Core.sdk.user.userId[3];
        }
        return this.cachedPlayerKey;
    }

    public static async saveToStorage(key: string, data: any) {
        try {
            const encryptedKey = this.getKey(key);
            const encryptedData = this.encryption(JSON.stringify(data));
            Storage.mockstorage.setItem(encryptedKey, encryptedData);
        } catch (e) {
            logger.debug('error saving to local storage: ' + e + ', for: ' + key);
        }
    }

    public static async getFromStorage(key: string) {
        let data = null;
        try {
            const encryptedKey = this.getKey(key);
            const storageData = Storage.mockstorage.getItem(encryptedKey);
            data = storageData ? this.encryption(storageData, true) : null;
        } catch (e) {
            // console.log(e);
            logger.error('error getting from local storage: ' + e + ', for: ' + key);
        }

        return data;
    }

    private static cachedPlayerKey: string;

    // switch to mock for testing...
    // private static mockstorage: any = new MockStorage();
    private static mockstorage: any = window.localStorage;

    private static encryption(data: string, decode: boolean = false) {
        let result = '';
        let lastChar = 144;
        const binaryKey = this.hash(`moji-${Core.sdk.user.userId}`);
        for (const char of data) {
            // tslint:disable-next-line: no-bitwise
            const decodedChar = String.fromCharCode(char.charCodeAt(0) ^ binaryKey ^ lastChar);
            result += decodedChar;
            lastChar = decode ? decodedChar.charCodeAt(0) : char.charCodeAt(0);
        }
        return result;
    }

    public static hash(s: string) {
        let h: number;
        let i: number;
        for (i = 0, h = 0xdeadbeef; i < s.length; i++) {
            // tslint:disable-next-line:no-bitwise
            h = Math.imul(h ^ s.charCodeAt(i), 2654435761);
        }
        // tslint:disable-next-line:no-bitwise
        return (h ^ (h >>> 16)) >>> 0;
    }

    private static getKey(key: string) {
        return this.encryption(`${this.playerKey}_${key}`);
    }
}
